import DownloadSnapshotButton from './component';

export * from './types';
export default DownloadSnapshotButton;
